import { Control, UseFormRegister, FieldValues, FieldPath } from 'react-hook-form';

import InputText from '@/components/InputText/InputText';
import SelectField from '@/components/SelectField/SelectField';
import {
  categories,
  supportAreaCategories,
  achievementPeriods,
  priorities,
} from '@/logics/supportPlan/supportPlan';
import { SupportPlanItem } from '@/types/supportPlan';

interface WithItems {
  items?: SupportPlanItem[];
}

type Props<T extends FieldValues & WithItems> = {
  index: number;
  control: Control<T>;
  register: UseFormRegister<T>;
};

export const ItemForm = <T extends FieldValues & WithItems>({
  index,
  control,
  register,
}: Props<T>) => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-row gap-4">
        <SelectField
          name={`items.${index}.category` as FieldPath<T>}
          label="項目"
          control={control}
          items={categories}
          required={true}
        />
      </div>
      <div className="flex flex-row gap-4">
        <InputText
          label="支援目標（具体的な到達目標）"
          type="textarea"
          required={false}
          {...register(`items.${index}.support_goal` as FieldPath<T>)}
        />
      </div>
      <div className="flex flex-row gap-4">
        <InputText
          label="支援内容(内容・支援の提供上のポイント・５領域との関連性等)"
          type="textarea"
          required={false}
          {...register(`items.${index}.support_content` as FieldPath<T>)}
        />
      </div>
      <div className="flex flex-row gap-4">
        <SelectField
          name={`items.${index}.five_area` as FieldPath<T>}
          label="５領域(※)との関連性等"
          control={control}
          items={supportAreaCategories}
          required={true}
        />
      </div>
      <div className="flex flex-row gap-4">
        <SelectField
          name={`items.${index}.achievement_period` as FieldPath<T>}
          label="達成時期"
          control={control}
          items={achievementPeriods}
          required={true}
        />
      </div>
      <div className="flex flex-row gap-4">
        <InputText
          label="担当者（提供機関）"
          type="textarea"
          required={false}
          {...register(`items.${index}.support_provider` as FieldPath<T>)}
        />
      </div>
      <div className="flex flex-row gap-4">
        <InputText
          label="留意事項（本人の役割を含む）"
          type="textarea"
          required={false}
          {...register(`items.${index}.notes` as FieldPath<T>)}
        />
      </div>
      <div className="flex flex-row gap-4">
        <SelectField
          name={`items.${index}.priority` as FieldPath<T>}
          label="優先順位"
          control={control}
          items={priorities}
          required={true}
        />
      </div>
    </div>
  );
};
